import { TravelineResourceDto } from '@/api/generated/fetch-client';

// export class Pagination {
//   constructor(
//     readonly totalItems?: number,
//     readonly totalPages?: number,
//     readonly currentPage?: number,
//     readonly itemsPerPage?: number,
//   ) {}

//   static fromDto(dto?: PaginationDto) {
//     return new Pagination(
//       dto?.totalItems,
//       dto?.totalPages,
//       dto?.currentPage,
//       dto?.itemsPerPage,
//     );
//   }
// }

export class Image {
  constructor(readonly url: string | null) {}

  static fromDto(dto: TravelineResourceDto) {
    return new Image(dto.url);
  }
}

export type WithRepository<T, R> = T & { repository: R };

export type ValueOf<T> = T[keyof T];

export type WithSignal<T = unknown> = T & { signal: AbortSignal };

export type PaginationMeta = { pageNumber?: number; pageSize?: number };

export class RepositoryException extends Error {}
